import { useLayoutEffect, type ReactElement, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { useUiLanguage } from '@/hooks/data/use-auth';
import { applyLanguage, i18n } from '@/lib/i18n/i18n';

export function LanguageProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const language = useUiLanguage();

  // Covers the first commit and cache writes that skip `_authenticated.tsx`'s `beforeLoad`.
  // Fire-and-forget: a signed-out session whose browser reports a non-default language can
  // flash the default once while that language's chunk downloads (see docs/ARCHITECTURE.md).
  useLayoutEffect(() => {
    void applyLanguage(language);
  }, [language]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
